import * as ActionTypes from "./ActionTypes";

export const setUsersListOnMap = (data) => {
  return {
    type: ActionTypes.SET_USERS_LIST_ON_MAP,
    data,
  };
};
